module.exports = __webpack_public_path__ + "static/media/edit_v2.b46aede0.svg";